// The following Loading spinner was implemented based on the following:
// https://tobiasahlin.com/spinkit/ - all credit is given to the author

import React from "react";
import { Spinner, Bounce } from "./styles";

const LoadingSpinner = () => (
  <Spinner>
    <Bounce delay={1} />
    <Bounce delay={2} />
    <Bounce />
  </Spinner>
);

export default LoadingSpinner;
